<template>
  <v-combobox
    v-model="currentItem"
    :disabled="disabled"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :label="$t(label)"
    :placeholder="$t(placeholder)"
    :filter="filter"
    :rules="rules"
    :clearable="clearable"
    :loading="loading"
    :readonly="readonly"
    @updated="updated"
  >
    <template slot="item" slot-scope="{ item, on }">
      <v-list-item :class="{ spec: item.disabled }" v-on="on">
        {{ item[itemText] }}
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: "ComboboxWithGroups",
  props: {
    item: {
      type: [String, Object]
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array
    },
    itemText: {
      type: String,
      default: "text"
    },
    itemValue: {
      type: String,
      default: "value"
    },
    rules: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    updated: {
      type: Function,
      default: function() {
        return new Function();
      }
    },
    tariffPlanId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    currentItem: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("updated", val);
      }
    }
  },
  methods: {
    filter(item, queryText) {
      let itemText = this.itemText;
      function filterItem(item) {
        // item has the same name
        return !!(
          item[itemText]
            .toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1 ||
          // group has the same name
          (item.group &&
            item.group
              .toLocaleLowerCase()
              .indexOf(queryText.toLocaleLowerCase()) > -1)
        );
      }
      return !!(
        (!item.disabled && filterItem(item)) ||
        (item.disabled &&
          this.items
            .filter(i => i.group === item.name)
            .find(i => filterItem(i)))
      );
    }
  }
};
</script>

<style scoped>
.spec {
  font-weight: 700;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background: #fff;
  opacity: 1;
  z-index: 1;
}
</style>
